import * as APIConfigurationService from './domain/APIConfigurationService/APIConfigurationService.client';
import { ClickstreamConfigurationService } from './domain/ClickstreamConfigurationService.client';
import { DatadogConfigurationService } from './domain/DatadogConfigurationService/DatadogConfigurationService.client';
import * as RouteConfigurationService from './domain/RouteConfigurationService/RouteConfigurationService.client';
import * as RuntimeConfigurationService from './domain/RuntimeConfigurationService/RuntimeConfigurationService.client';

/**
 * Config that is passed into the client via the DOM, similar to the old publicRuntimeConfig
 */

export type InjectedConfig = {
    environment: RuntimeConfigurationService.ClientAvailableEnvironmentVariables;
};

declare global {
    interface Window {
        clientRuntimeConfig: InjectedConfig;
    }
}

/**
 * Provides a standardized configuration interface for all client side code. Cannot be used on the server, as it relies on Browser APIs
 */

export class ConfigProvider {
    static #instance: ConfigProvider;
    readonly #runtimeConfig: RuntimeConfigurationService.ConfigProvider;
    readonly #apiConfig: APIConfigurationService.ConfigProvider;
    readonly #datadogConfig: DatadogConfigurationService.ConfigProvider;
    readonly #clickstreamConfig: ClickstreamConfigurationService.ConfigProvider;
    readonly #routeConfiguration: RouteConfigurationService.ConfigProvider;
    private constructor() {
        this.#runtimeConfig = RuntimeConfigurationService.ConfigProvider.getInstance();
        this.#apiConfig = new APIConfigurationService.ConfigProvider({
            runtimeConfig: this.#runtimeConfig,
        });
        this.#datadogConfig = new DatadogConfigurationService.ConfigProvider({
            runtimeConfig: this.#runtimeConfig,
        });
        this.#clickstreamConfig = new ClickstreamConfigurationService.ConfigProvider({
            runtimeConfig: this.#runtimeConfig,
        });
        this.#routeConfiguration = new RouteConfigurationService.ConfigProvider({
            runtimeConfig: this.#runtimeConfig,
        });
    }

    public static getInstance(): ConfigProvider {
        if (!ConfigProvider.#instance) {
            ConfigProvider.#instance = new ConfigProvider();
        }
        return ConfigProvider.#instance;
    }

    public get runtimeConfig(): RuntimeConfigurationService.ConfigProvider {
        return this.#runtimeConfig;
    }

    public get apiConfig(): APIConfigurationService.ConfigProvider {
        return this.#apiConfig;
    }

    public get clickstreamConfig(): ClickstreamConfigurationService.ConfigProvider {
        return this.#clickstreamConfig;
    }

    public get datadogConfig(): DatadogConfigurationService.ConfigProvider {
        return this.#datadogConfig;
    }

    public get routeConfiguration(): RouteConfigurationService.ConfigProvider {
        return this.#routeConfiguration;
    }
}
